export function isGitHubAstroEnabledServer(): boolean {
  return process.env.GITHUB_ASTRO_ENABLED === 'true';
}

export function isGitHubAstroEnabledClient(): boolean {
  return process.env.NEXT_PUBLIC_GITHUB_ASTRO_ENABLED === 'true';
}

export function isGitHubLivePreviewEnabledServer(): boolean {
  return process.env.GITHUB_LIVE_PREVIEW_ENABLED === 'true';
}

export function isGitHubLivePreviewEnabledClient(): boolean {
  return process.env.NEXT_PUBLIC_GITHUB_LIVE_PREVIEW_ENABLED === 'true';
}

export function isGitHubNextEnabledServer(): boolean {
  return process.env.GITHUB_NEXT_ENABLED === 'true';
}
export function isGitHubNextEnabledClient(): boolean {
  return process.env.NEXT_PUBLIC_GITHUB_NEXT_ENABLED === 'true';
}
export function isGitHubWebsiteEnabledServer(): boolean {
  return isGitHubAstroEnabledServer() || isGitHubNextEnabledServer();
}
export function isGitHubWebsiteEnabledClient(): boolean {
  return isGitHubAstroEnabledClient() || isGitHubNextEnabledClient();
}
export function isGitHubFrameworkEnabledServer(framework: 'astro' | 'next'): boolean {
  return framework === 'next' ? isGitHubNextEnabledServer() : isGitHubAstroEnabledServer();
}

export function isGitHubBindingEnabledClient(
  binding: { framework?: unknown; detected_astro?: boolean } | null | undefined
): boolean {
  const framework = binding?.framework ?? (binding?.detected_astro ? 'astro' : null);
  return framework === 'next'
    ? isGitHubNextEnabledClient()
    : framework === 'astro' && isGitHubAstroEnabledClient();
}
